/**
 * Extract a property value from a GraphQL-shaped node.
 * Searches the `properties` array for a matching `propertyName`.
 *
 * @deprecated This function works with the old GraphQL response shape.
 * It will be removed once all consumers migrate to the Delivery API's flat property objects.
 */
export function extractProperty(
  node: any,
  propertyName: string,
  isMedia?: boolean,
): any {
  if (!node?.properties) return undefined
  const prop = Array.isArray(node.properties)
    ? node.properties.find(
        (p: any) => p.propertyName === propertyName || p.alias === propertyName,
      )
    : undefined

  if (!prop) return undefined

  const val = prop.propertyValue ?? prop.value
  if (!val) return undefined

  if (isMedia) {
    const items = val.mediaItems ?? val
    return Array.isArray(items) ? items : val
  }

  if (Array.isArray(val.blocks)) return val.blocks
  if (Array.isArray(val.links)) return val.links
  if (val.value !== undefined) return val.value
  if (Array.isArray(val.mediaItems)) {
    // Return first URL as string for non-media mode, matching old behavior
    if (val.mediaItems.length > 0) return val.mediaItems[0]?.url
    return undefined
  }
  return val
}
